export default {
  доцент: 'доцент',
  профессор: 'профессор',
  'старший научный сотрудник': 'старший научный сотрудник',
  'младший научный сотрудник': 'младший научный сотрудник',
  академик: 'академик',
  'член-корреспондент': 'член-корреспондент',
};



// WEBPACK FOOTER //
// ./src/data/academic-titles.js